/* Slider Card Travels */
var sliderCardTravels = function() {
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if ($('.slider-card-travels').length > 0) {
        if ($('.slider-card-travels .slick-slide').length == 0) {
            $('.slider-card-travels').each(function() {
                var slidesContainer = $(this);

                slidesContainer.slick({
                    dots: true,
                    arrows: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    variableWidth: true
                });
            });
        }
    }
};

$(document).ready(function() {
    // sliderCardTravels();
});